export const STEAM_LOCALES = [
  { steam: "koreana", name: "Korean", nativeName: "한국어" },
  { steam: "english", name: "English", nativeName: "English" },
  { steam: "japanese", name: "Japanese", nativeName: "日本語" },
  { steam: "schinese", name: "Simplified Chinese", nativeName: "简体中文" },
  { steam: "tchinese", name: "Traditional Chinese", nativeName: "繁體中文" },
  { steam: "french", name: "French", nativeName: "Français" },
  { steam: "german", name: "German", nativeName: "Deutsch" },
  { steam: "spanish", name: "Spanish", nativeName: "Español" },
  { steam: "latam", name: "Latin Am. Spanish", nativeName: "Español (LA)" },
  { steam: "portuguese", name: "Portuguese", nativeName: "Português" },
  { steam: "brazilian", name: "Brazilian Portuguese", nativeName: "Português (BR)" },
  { steam: "russian", name: "Russian", nativeName: "Русский" },
  { steam: "italian", name: "Italian", nativeName: "Italiano" },
  { steam: "polish", name: "Polish", nativeName: "Polski" },
  { steam: "dutch", name: "Dutch", nativeName: "Nederlands" },
  { steam: "danish", name: "Danish", nativeName: "Dansk" },
  { steam: "finnish", name: "Finnish", nativeName: "Suomi" },
  { steam: "norwegian", name: "Norwegian", nativeName: "Norsk" },
  { steam: "swedish", name: "Swedish", nativeName: "Svenska" },
  { steam: "czech", name: "Czech", nativeName: "Čeština" },
  { steam: "hungarian", name: "Hungarian", nativeName: "Magyar" },
  { steam: "romanian", name: "Romanian", nativeName: "Română" },
  { steam: "bulgarian", name: "Bulgarian", nativeName: "Български" },
  { steam: "greek", name: "Greek", nativeName: "Ελληνικά" },
  { steam: "turkish", name: "Turkish", nativeName: "Türkçe" },
  { steam: "thai", name: "Thai", nativeName: "ไทย" },
  { steam: "ukrainian", name: "Ukrainian", nativeName: "Українська" },
  { steam: "vietnamese", name: "Vietnamese", nativeName: "Tiếng Việt" },
  { steam: "indonesian", name: "Indonesian", nativeName: "Bahasa Indonesia" },
];

export function toSteamLang(lang: string): string {
  if (lang === "ko") return "koreana";
  if (lang === "en") return "english";
  return "all";
}
